import { render } from "./NovusCatalog.vue?vue&type=template&id=26253d0e&scoped=true"
import script from "./NovusCatalog.vue?vue&type=script&lang=js"
export * from "./NovusCatalog.vue?vue&type=script&lang=js"

import "./NovusCatalog.vue?vue&type=style&index=0&id=26253d0e&scoped=true&lang=css"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26253d0e"]])

export default __exports__